module.exports = __webpack_public_path__ + "static/img/img12.15ad5e93.png";